module.exports = __webpack_public_path__ + "fa9c079d723e259450fc5b3d1501a2e9.svg";